import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { AgentList } from "../../../components/Agent/AgentList";
import { ColumnLayout } from "../../../components/Layout/ColumnLayout";
import { Page } from "../../Page";
import { EmbeddedAppTriggerLocation } from "@/embeddedApps/EmbeddedAppTriggerLocation";

export const AgentPage = () => {
    return (
        <Page title="Agents">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Distribution</Breadcrumb.Item>
                        <Breadcrumb.Item>Agents</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                    <EmbeddedAppTriggerLocation id="distribution.agents.headerBar" />
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <AgentList />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
